import Link from "next/link";
import { useEffect, useState } from "react";
import { BlueButton } from "../Button";
import styles from "./index.css";
import { useTable, usePagination } from "react-table";

import cookies from "js-cookie";
import { DOMAIN } from "../../utils/constants";

const CookiePopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const key = "acceptCookies";
  const handleAcceptCookies = (value) => {
    try {
      cookies.set(key, value, {
        domain: DOMAIN,
        secure: process.env.ENVIRONMENT !== "development" ? true : false,
      });
      setIsVisible(false);
    } catch (error) {
      setIsVisible(true);
    }
  };

  useEffect(() => {
    const cookiesResponse = cookies.get(key);
    !cookiesResponse && setIsVisible(true);
  }, [isVisible]);

  if (isVisible) {
    return (
      <>
        <div className="banner-dialog">
          <div className="banner-container">
            <div className="text">
              <p className="green">We value your privacy</p>
              <p>
                We use cookies to identify you as a user and improve your
                browsing experience, serve personalized ads or content, and
                analyze our traffic. By clicking "Accept", you consent to our
                use of cookies and agree to our{" "}
                <Link href="/terms-of-service" passHref>
                  <a>privacy policy</a>
                </Link>
              </p>
            </div>

            <div className="actions">
              <BlueButton
                onClick={() => handleAcceptCookies("accept")}
                className="cicod-btn-lg"
              >
                Accept
              </BlueButton>
              <a
                onClick={() => handleAcceptCookies("reject")}
                style={{ color: "#035e35" }}
              >
                Reject
              </a>
            </div>
          </div>
        </div>

        <style jsx>{styles}</style>
      </>
    );
  }

  return <></>;
};

export default CookiePopup; 
